import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { ConfigProduct, ConfigSoilInfo, ConfigWater, ConfigCrop, Lot, LotSummary, Pua, ConfigFertilization, PuaLot, PuaStatus, Anomalies, Print, Spreading, Interdiction, PuaPlotGroup } from "./models/PuaModel";

export default class PuaVuexModule extends AbacoVuexModule {
    @State({ default: false }) canView!: boolean;
    @State({ default: false }) canEdit!: boolean;
    @State({ default: [] }) puas!: Pua[];
    @State() currentPua!: Pua;
    @State({ default: [] }) plots!: Lot[];
    @State({ default: [] }) groupedPlots!: PuaPlotGroup[];

    @State() curLotSummary!: LotSummary;
    @State() curPuaLot!: PuaLot;
    @State({ default: [] }) waters!: ConfigWater[];
    @State({ default: [] }) fertilizers!: ConfigFertilization[];
    @State({ default: [] }) crops!: ConfigCrop[];
    @State({ default: [] }) products!: ConfigProduct[];
    @State({ default: [] }) soilInfos!: ConfigSoilInfo;
    @State({ default: [] }) nitrogenEfficiency!: any;
    @State({ default: 3 }) currentAction!: number;
    @State({ default: [] }) puaStatus!: PuaStatus[];
    @State({ default: [] }) anomalies!: Anomalies[];
    @State({ default: [] }) prints!: Print[];
    @State({ default: [] }) spreadings!: Spreading[];
    @State({ default: [] }) interdictions!: Interdiction[];
    @State({ default: false }) multiplot!: boolean;
    @State({ default: 0 }) cancelEdit!: number;

    @State() itemToEdit!: any;
}
